export const validateForm = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Name is required";
  }

  if (!values.email) {
    errors.email = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }

  if (!values.phone) {
    errors.phone = "Phone number is required";
  } else if (!/^[0-9]{10}$/i.test(values.phone)) {
    errors.phone = "Phone number must be 10 digits";
  }

  return errors;
};
export const errorFormFieldHighlight =
  "border border-cf-red-400 outline-none w-full py-3 px-4 rounded";
export const validFormFieldHighlight =
  "border border-gray-300 outline-none w-full py-3 px-4 rounded hover:border-[#6933d3] focus:border-[#6933d3]";
